import { defineStore } from "pinia";
import { getFilteredObjectByValuePath } from "@/pages/product_card/tools/object";
import axios from "axios";
import recursivelyLowercaseJSONKeys from "recursive-lowercase-json";

export const useReviewsStore = defineStore("reviews", {
  state: () => {
    return {
      reviews: {
        list: {},
        average_rating: 0,
        count: 0,
        count_string: "0 отзывов",
        stars_width: 0,
      },
      reviewsPopupOpen: false,
      questionsPopupOpen: false,
      reviewInProcess: {
        rating: 5,
        text: "",
        question: "",
        files: [],
        sent: false,
      },
      loading: true,
    };
  },
  actions: {
    openReviewsPopup() {
      this.reviewsPopupOpen = true;
    },
    closeReviewsPopup() {
      this.reviewsPopupOpen = false;
    },
    openQuestionsPopup() {
      this.questionsPopupOpen = true;
    },
    closeQuestionsPopup() {
      this.questionsPopupOpen = false;
    },
    fillData(data) {
      this.reviews = recursivelyLowercaseJSONKeys(data);
    },
    async getReviewsData(productCode, productId) {
      return axios({
        method: "post",
        url: "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getReviewsData",
        params: {
          productCode,
          productId,
        },
      });
    },
  },
  getters: {
    getReviewsCount(state) {
      return Object.keys(
        getFilteredObjectByValuePath(state.reviews.list, "is_review", true)
      ).length;
    },
    getQuestionsCount(state) {
      return Object.keys(
        getFilteredObjectByValuePath(state.reviews.list, "is_review", false)
      ).length;
    },
    getReviews(state) {
      return getFilteredObjectByValuePath(
        state.reviews.list,
        "is_review",
        true
      );
    },
    getReviewsForSlider(state) {
      return Object.entries(state.getReviews).map((entry) => entry[1]);
    },
    getQuestions(state) {
      return getFilteredObjectByValuePath(
        state.reviews.list,
        "is_review",
        false
      );
    },
    getQuestionsForSlider(state) {
      return Object.entries(state.getQuestions).map((entry) => entry[1]);
    },
    getAverageRating(state) {
      return state.reviews.average_rating;
    },
    isReviewsPopupOpen(state) {
      return state.reviewsPopupOpen;
    },
    isQuestionsPopupOpen(state) {
      return state.questionsPopupOpen;
    },
    getWritten(state) {
      return state.reviewInProcess;
    },
    isReviewSent(state) {
      return state.reviewInProcess.sent === true;
    },
  },
});
